'use strict';

export class Register
{
    constructor()
    {
        this.init()
    }

    init()
    {
        $(document).on('submit', '.js-auth-form', function(e){
            e.preventDefault()
            let form = $(this)
            let data = form.serialize()

            $.ajax({
                url: form.attr('action'),
                method: 'POST',
                data: data,
                success: function(e) {
                    location.reload();
                },
                error: function(e) {
                    alert(e.responseJSON.errors[0]);
                }
            })
        })

        $(document).on('submit', '.js-form-forgot-email', function(e){
            e.preventDefault()
            let form = $(this)
            let data = form.serialize()

            $.ajax({
                url: form.attr('action'),
                method: 'POST',
                data: data,
                success: function(e) {
                    form.html("<div>Сообщение для восстановления пароля отправлено на email</div>")
                },
                error: function(e) {
                    alert(e.responseJSON.errors[0]);
                }
            })
        })
    }
}